import * as React from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'

import DoodleBackground from '../../components/doodle-background'
import SocialMedia from '../../components/social-media'

import styles from './engagement.module.scss'

const isSocialMediaDisabled = true

interface IEngagementProps {
  inverted?: boolean
  title?: React.ReactNode
  description?: React.ReactNode
  variant?: 'brand' | 'free'
}
const Engagement = ({ variant = 'brand', inverted, title, description }: IEngagementProps) => {
  if (isSocialMediaDisabled) {
    return null
  }
  return (
    <div className={`${styles.root} ${inverted ? styles.inverted : ''} ${variant === 'free' ? styles.free : ''}`}>
      <h2 className={styles.title}>
        {title ? (
          title
        ) : (
          <FormattedHTMLMessage
            defaultMessage={`
              <span class="block-sm">Hos oss händer det massor hela tiden.</span>
              <span class="block-sm">Följ oss och upplev det vi kallar <a class="{classLink}" href="#dooerlife">#dooerlife</a></span>
            `}
            id="component.engagement.default-title"
            values={{
              classLink: styles.link,
            }}
          />
        )}
      </h2>

      <p className={styles.description}>
        {description ? (
          description
        ) : (
          <FormattedMessage
            defaultMessage="Vi expanderar med nya kontor runt om&nbsp;i&nbsp;landet, släpper nya produkter, testar massor av saker och vi gillar att dela med oss. Följ oss på sociala medier så missar du ingenting."
            id="component.engagement.description"
          />
        )}
      </p>

      <SocialMedia size="large" variant={variant} />
      {!inverted && <DoodleBackground variant="bottomLeft" />}
    </div>
  )
}

export default Engagement
